// <upload var="lease.customFields.sitePlan"/>

angular.module("LeasePilot").directive("leaseUpload", [
  function() {
    const leaseUploadLink = function(scope, element, attrs) {
      scope.uploads = [];

      scope.$watch("name", function(newval) {
        scope.uploads = newval?.images;
      });

      scope.adjustImageWidth = function(img) {
        const maxWidth = 672;
        if (img.naturalWidth > maxWidth) {
          img.setAttribute("width", maxWidth + 'px');
        } else {
          img.setAttribute("width", img.naturalWidth + 'px');
        }
      };
    };

    return {
      restrict: "E",
      scope: {
        name: "=",
        isChanging: "="
      },
      template: `<div ng-repeat='upload in uploads track by $index' style='text-align: center' class='center-block' ng-class='{ adding: isChanging, added: !isChanging}'><img ng-src='{{ upload }}' style='max-width: 672px;' image-on-load/></div>`,
      link: leaseUploadLink
    };
  }
]);
